import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import CheckboxField from '../../../components/Fields/CheckboxField';
import { viewByFilterStyle } from './viewByFilterStyle';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(() => viewByFilterStyle);

export const ViewByFilter = ({ classes, title, viewByAll, viewByTickets, viewByLiveStream }) => {
  const defaultClasses = useStyles();
  const clazz = classes || defaultClasses;

  return (
    <>
      <div className={clazz.viewByLabel}>{title}</div>
      <CheckboxField
        tabIndex={0}
        className={classnames(clazz.checkboxViewBy, clazz.checkboxViewBy_disabled)}
        instanceId="all"
        checked={viewByAll.isChecked}
        onChange={viewByAll.onChange}
        name="filter-viewby-all"
        label={viewByAll.label}
      />
      <CheckboxField
        tabIndex={0}
        className={clazz.checkboxViewBy}
        instanceId="tickets"
        checked={viewByTickets.isChecked}
        onChange={viewByTickets.onChange}
        name="filter-viewby-tickets"
        label={viewByTickets.label}
      />
      <CheckboxField
        tabIndex={0}
        className={classnames(clazz.checkboxViewBy, clazz.checkboxViewBy_disabled)}
        instanceId="live_stream"
        checked={viewByLiveStream.isChecked}
        onChange={viewByLiveStream.onChange}
        name="filter-viewby-live-stream"
        label={viewByLiveStream.label}
      />
    </>
  );
};
